import { useEffect, useState } from "react"
import ImageGallery from "react-image-gallery"
import { api } from "../../services";


const GalleryContainer = () => {
  const [galleryData, setGalleryData] = useState([]);
  const [filteredGallery, setFilteredGallery] = useState([]);
  const [isGalleryOpened, setIsGalleryOpened] = useState(false);
  const [startIndex, setStartIndex] = useState();
  const [categories, setCategories] = useState([]);
  const [expandedCategories, setExpandedCategories] = useState([]);

  const openGalleryFor = (image) => {
    const idx = filteredGallery.findIndex(g => g.media_id === image.media_id);
    if (idx === -1) return;
    document.querySelector('.image-gallery').classList.add('showGallery');
    setStartIndex(idx);
    setIsGalleryOpened(true);
  }

  const closeGallery = () => {
    document.querySelector('.image-gallery').classList.remove('showGallery');
    setIsGalleryOpened(false);
    setStartIndex(null);
  }

  const toggleCategory = (catId) => {
    setExpandedCategories(prev =>
      prev.includes(catId) ? prev.filter(id => id !== catId) : [...prev, catId]
    );
  };

  const selectTag = (event) => {
    const tagName = event.target.innerHTML.toUpperCase();
    if (tagName === "PRIKAŽI SVE") setFilteredGallery(galleryData);
    else {
      const filtered = galleryData.filter(g => (g.categories[0] && g.categories[0].title.toUpperCase()) === tagName)
      setFilteredGallery(filtered);
    }
  }

  useEffect(() => {
    const gallery = document.querySelector('.image-gallery-slides');
    if (!gallery) return;
    const close = document.createElement('div');
    const line1 = document.createElement('div');
    line1.classList.add('line1');
    const line2 = document.createElement('div');
    line2.classList.add('line2');
    close.classList.add('gallery-close-button');
    close.appendChild(line1);
    close.appendChild(line2);

    close.addEventListener('click', closeGallery);
    gallery.appendChild(close);
  }, [galleryData])

  useEffect(() => {
    api.gallery.getActiveImages().then(res => {
      if (!res) return;
      setGalleryData(res);
      setFilteredGallery(res);
    })

    api.categories.getGalleryCategories().then(res => {
      if (!res) return;
      setCategories(res)
    })
  }, [])

  const getCategoryImages = (catId) =>
    filteredGallery.filter(g => g.categories.some(c => c.id === catId));

  return (
    <>
      {/* <img src="/images/header_images/galerija.webp" className="w-100 d-none d-md-block" alt=""></img>
      <img src="/images/header_images/galerija_mobile.webp" className="w-100 d-md-none" alt=""></img> */}
      <div>
        <h2 className="shadowtitle ps-4 ps-md-5 text-left">GALERIJA</h2>
      </div>
      <div className="ps-4 ps-md-5 pe-3 pe-md-4">
        <div className="row g-0 mb-5">
          <div className="col-12 col-lg-2 order-last order-lg-first">
            <div className="text-black mb-5 text-center text-lg-start categories d-flex flex-column align-items-center align-items-lg-start">
              <h5 className="gallery-category-title mb-4">Kategorije</h5>
              {categories.map((item, key) => (
                <div name={item.title} onClick={selectTag} role="button" key={key}>{item.title}</div>
              ))}
              <div onClick={selectTag} role="button" className="mt-3">Prikaži sve</div>
            </div>
          </div>
          <div className="col-1 col-md-2 d-lg-none order-first"></div>
          <div className="col-12 col-md-8 order-first order-lg-last">
            {categories.map(cat => {
              const catImages = getCategoryImages(cat.id);
              if (!catImages.length) return null;
              const [big, small1, small2, ...rest] = catImages;
              const isExpanded = expandedCategories.includes(cat.id);

              return (
                <div className="gallery-category mb-5" key={cat.id}>
                  <h4 className="text-start mb-3">{cat.title}</h4>
                  <div className="gallery-preview">
                    {big && (
                      <img
                        className="big radius-16"
                        src={`${process.env.REACT_APP_NOVOINVESTMENT_WEB_URL + big.thumbnail}`}
                        role="button"
                        onClick={() => openGalleryFor(big)}
                        alt=""
                      />
                    )}
                    {small1 && (
                      <img
                        className="small radius-16"
                        src={`${process.env.REACT_APP_NOVOINVESTMENT_WEB_URL + small1.thumbnail}`}
                        role="button"
                        onClick={() => openGalleryFor(small1)}
                        alt=""
                      />
                    )}
                    {small2 && (
                      <img
                        className="small radius-16"
                        src={`${process.env.REACT_APP_NOVOINVESTMENT_WEB_URL + small2.thumbnail}`}
                        role="button"
                        onClick={() => openGalleryFor(small2)}
                        alt=""
                      />
                    )}
                  </div>
                  {isExpanded && rest.length > 0 && (
                    <div className="row mt-3">
                      {rest.map(item => (
                        <div key={item.media_id} className="col-6 col-md-4 mb-3">
                          <img
                            src={`${process.env.REACT_APP_NOVOINVESTMENT_WEB_URL + item.thumbnail}`}
                            className="w-100 radius-16"
                            role="button"
                            onClick={() => openGalleryFor(item)}
                            alt=""
                          />
                        </div>
                      ))}
                    </div>
                  )}
                  {rest.length > 0 && (
                    <div
                      className="btn_load_more hover_btn_load_more btn_large w-auto px-4 mt-3 mb-4"
                      onClick={() => toggleCategory(cat.id)}
                    >
                      {isExpanded ? "PRIKAŽI MANJE" : "PRIKAŽI SVE"}
                    </div>
                  )}
                </div>
              );
            })}
            {!filteredGallery.length && (
              <p className="no-data text-center">Nema slika u ovoj kategoriji</p>
            )}
          </div>
        </div>
      </div>
      <div className='gallery_container'>
        <ImageGallery
          items={filteredGallery.map((item, key) => ({ ...item, original: `${process.env.REACT_APP_NOVOINVESTMENT_WEB_URL + item.original}`, thumbnail: `${process.env.REACT_APP_NOVOINVESTMENT_WEB_URL + item.thumbnail}` }))}
          startIndex={startIndex}
          showPlayButton={false}
          showFullscreenButton={false}
        />
      </div>
      <div onClick={closeGallery} className={`${isGalleryOpened ? "fullOverlay" : ""}`}></div>
    </>
  )
}
export default GalleryContainer